import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { styled } from 'styletron-react';
import { useTestIdAttribute } from '../../hooks/useTestIdAttribute';
import { ButtonContainer } from '../Button/ButtonContainer';
import { Icon } from '../Icon/Icon';
import { Rotator } from '../Rotator/Rotator';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
/**
 * Using span instead of button to avoid nested buttons error.
 * FilterButton is already wrapped in ButtonContainer (which renders a button),
 * so this clear action must be a non-button element.
 */
const StyledClearButton = styled('span', {
    cursor: 'pointer',
    lineHeight: 0,
});
const ICON_CLOSED_ROTATION_DEGREES = 90;
const ICON_OPENED_ROTATION_DEGREES = 270;
export const FilterButton = ({ open, isActive, activeText, inactiveText, cancelText, width, testId, clearTestId, onClick, onClear, }) => {
    const clearClicked = useRef(false);
    const testIdAttribute = useTestIdAttribute(testId);
    const clearTestIdAttribute = useTestIdAttribute(clearTestId);
    const color = isActive ? 'action' : 'grey';
    const variant = isActive ? 'dark' : 'light';
    const textColor = isActive ? 'white' : 'dark';
    const text = isActive ? activeText : inactiveText;
    const iconColor = isActive ? 'white' : 'grey';
    const rotatedIconDegrees = open
        ? ICON_CLOSED_ROTATION_DEGREES
        : ICON_OPENED_ROTATION_DEGREES;
    const cancelTextUpper = cancelText.toUpperCase();
    const handleClearClick = () => {
        onClear();
        clearClicked.current = true;
    };
    const handleFilterClick = () => {
        if (!clearClicked.current)
            onClick();
        clearClicked.current = false;
    };
    return (_jsx(ButtonContainer, { color: color, size: 'small', variant: variant, width: width, onClick: handleFilterClick, ...testIdAttribute, children: _jsxs(FlexContainer, { verticalAlign: 'center', horizontalAlign: 'spaceBetween', children: [_jsxs(FlexContainer, { verticalAlign: 'center', gap: true, children: [_jsx(Text, { variant: 'b2', color: textColor, children: text }), isActive && (_jsx(StyledClearButton, { onClick: handleClearClick, ...clearTestIdAttribute, children: _jsx(Text, { variant: 'b3', color: 'white', underline: true, children: cancelTextUpper }) }))] }), _jsx(Rotator, { rotationInDeg: rotatedIconDegrees, children: _jsx(Icon, { name: 'ChevronLeft', color: iconColor }) })] }) }));
};
